import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";

@Injectable({
  providedIn: "root",
})
export class ProjectTaskService {
  constructor(private apiService: ApiBaseService) {}

  async getProjektItem(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/GetProjektItem",
      payLoad,
      true,
      true
    );
  }

  async getProjektAufgaben(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/GetProjektAufgaben",
      payLoad,
      true,
      true
    );
  }

  async writeProjectTasks(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/WriteProjectTasks",
      payLoad,
      true,
      true
    );
  }

  async removeProjektAufgabeDocument(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/RemoveProjektAufgabeDocument",
      payLoad,
      true,
      true
    );
  }

  async UploadTaskFile(payLoad: any): Promise<any> {
    return this.apiService.httpRequestForm(
      "ProjectTasksService/UploadTaskFile",
      payLoad,
      true,
      true
    );
  }

  async getProjectTaskDocList(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/GetProjectTaskDocList",
      payLoad,
      true,
      true
    );
  }

  async moveFileToSharepoint(payLoad: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/MoveFileToSharepoint",
      payLoad,
      true,
      false
    );
  }

  async getProjectTaskFile(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/GetProjectTaskFile",
      payload,
      true,
      true
    );
  }

  async getProjectTaskCommsList(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/GetProjectTaskCommsList",
      payload,
      true,
      true
    );
  }

  async writeTaskNote(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/WriteTaskNote",
      payload,
      true,
      true
    );
  }

  async getProjectTaskCommsFile(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/GetProjectTaskCommsFile",
      payload,
      true,
      true
    );
  }

  async getMultipleDocumentsForDownload(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "DashboardService/GetMultipleDocumentsForDownload",
      payload,
      true,
      true
    );
  }

  async saveProjectTask(payload: any): Promise<any> {
    return this.apiService.httpRequest(
      "ProjectTasksService/SaveProjectTask",
      payload,
      true,
      true
    );
  }
}
